/**
 * @fileoverview Limit Suspension Guard - タイマー制御の停止理由を集約
 * gameplay 層内で外部要因による一時停止を管理するための軽量ヘルパー。
 */

const activeReasons = new Set();

/**
 * 一時停止理由を登録
 * @param {string} reason - 理由を表す識別子
 */
export function suspend(reason = 'unknown') {
  activeReasons.add(reason || 'unknown');
}

/**
 * 一時停止理由を解除
 * @param {string} reason - 理由を表す識別子
 */
export function resume(reason = 'unknown') {
  activeReasons.delete(reason || 'unknown');
}

/**
 * 一時停止状態かどうか
 * @returns {boolean} true の場合タイマーを停止すべき
 */
export function isSuspended() {
  return activeReasons.size > 0;
}

/**
 * 状態をリセット（ドライバの start/stop で使用）
 */
export function reset() {
  activeReasons.clear();
}
